
export const INZERAT_CRUD_ENDPOINT = "user/inzerat";
export const INZERAT_VIEW_ENDPOINT = "user/inzeratview";

export const PREPRAVA_CRUD_ENDPOINT = "user/preprava";
export const PREPRAVA_VIEW_ENDPOINT = "user/prepravaview";

export const VOZIDLO_CRUD_ENDPOINT = "user/vozidlo";
export const VOZIDLO_VIEW_ENDPOINT = "user/vozidloview";